module.exports = __webpack_public_path__ + "static/media/synth_02.1a19a35c.mp3";